export default {
  /*
   * index() lista las transacciones
   */
  index(params) {
    return Vue.http.get('billing/transactions', {params}).then(response => response.data.data)
  }
}
